export default __webpack_public_path__ + "static/media/Logo 3-text.fcc07643.png";